(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const BREAKPOINT = 989;
  const getDrawerContainer = () => document.getElementById('Details-menu-drawer-container');
  const getDrawer = () => document.getElementById('menu-drawer');

  const keepDrawerOpen = () => {
    const container = getDrawerContainer();
    const drawer = getDrawer();
    if (!container || !drawer) return;
    container.open = true;
    container.classList.add('menu-opening');
    drawer.style.transform = 'translateX(0)';
    drawer.style.visibility = 'visible';
  };

  const closeOtherPanels = (currentButton) => {
    document.querySelectorAll('.menu-drawer__submenu-toggle[aria-expanded="true"]').forEach((button) => {
      if (button === currentButton) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  };

  const togglePanel = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    const open = button.getAttribute('aria-expanded') === 'true';
    closeOtherPanels(button);
    button.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;

    if (!open) {
      keepDrawerOpen();
      requestAnimationFrame(keepDrawerOpen);
      setTimeout(keepDrawerOpen, 0);
    }
  };

  const initMobileDrawerMenus = () => {
    if (window.innerWidth > BREAKPOINT) return;

    const container = getDrawerContainer();

    document.querySelectorAll('.menu-drawer__submenu-toggle').forEach((button) => {
      if (button.dataset.mobileDrawerReady === 'true') return;
      button.dataset.mobileDrawerReady = 'true';

      button.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }, true);

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        togglePanel(button);
      }, true);

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        togglePanel(button);
      }, true);
    });

    if (container && container.dataset.mobileDrawerToggleReady !== 'true') {
      container.dataset.mobileDrawerToggleReady = 'true';

      container.addEventListener('toggle', () => {
        if (window.innerWidth > BREAKPOINT) return;

        const openPanel = container.querySelector('.menu-drawer__submenu-toggle[aria-expanded="true"]');
        if (openPanel && !container.open) {
          keepDrawerOpen();
        }
      });
    }
  };

  const resetMobilePanels = () => {
    document.querySelectorAll('.menu-drawer__submenu-toggle').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  };

  initMobileDrawerMenus();

  document.addEventListener('shopify:section:load', initMobileDrawerMenus);

  window.addEventListener('resize', () => {
    if (window.innerWidth > BREAKPOINT) {
      resetMobilePanels();
    } else {
      initMobileDrawerMenus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
